export default function(o, done){

  o.sounds = {
    main: {
      file: 'omb_collage.mp3',
      volume: 1,
      loop: true,
    },
    tick: {
      file: 'omb_beep.mp3',
      volume: 0.05,
      loop: false,
    },
    shuffle: {
      file: 'omb_shuffle.mp3',
      volume: 1,
      loop: false,
    },
  }

  var serverUrl = o.util.getUrl('sound')

  var totalSoundsLoaded = 0

  var prepareSound = function(id){

    var s = o.sounds[id]

    var sound =
      new Audio(`${serverUrl}${s.file}`)

    sound.volume = 0

    sound.load()

    if(s.loop){
      sound
      .addEventListener('ended', function() {
        this.currentTime = 0
        this.play()
      }, false)
    }

    sound
    .addEventListener('canplaythrough', function() {
      sound.removeEventListener('canplaythrough', this)
      if(++totalSoundsLoaded == _.size(o.sounds)){
        done()
      }
    }, false)

    o.sounds[id].sound = sound

  }

  for (var sound in o.sounds) {
    prepareSound(sound)
  }

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/app/sounds.js